import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import STRINGS from "../../constants/strings";

export default function ConfirmStorePickup(props) {
  const {
    show,
    setIsStorePickup,
    setShippingCharges,
    closeModal,
    isMobile,
  } = props;
  return (
    <Modal show={show} className="confirm-order-modal">
      <Alert variant="success" className={isMobile ? "w-100" : "w-50"}>
        <Alert.Heading>Confirm Store Pickup</Alert.Heading>
        <hr />
        <p>{STRINGS.CONFIRM_STORE_PICKUP_DECLARATION}</p>
        <div className="d-flex justify-content-end mt-2">
          <div
            className={`d-flex justify-content-between`}
            style={{ width: isMobile ? "75%" : "47%" }}
          >
            <Button
              className="mr-2"
              onClick={() => {
                setIsStorePickup(true);
                setShippingCharges(0);
                closeModal();
              }}
              variant="outline-success"
              style={{ width: "35%" }}
            >
              Confirm
            </Button>
            <Button
              style={{ width: "65%" }}
              onClick={() => {
                setIsStorePickup(false);
                setShippingCharges(null);
                closeModal();
              }}
              variant="outline-success"
            >
              Home Delivery
            </Button>
          </div>
        </div>
      </Alert>
    </Modal>
  );
}
